export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): {
    (this: any, ...args: Parameters<T>): void;
    cancel(): void;
} {
    let timeout: ReturnType<typeof setTimeout>;

    function debounced(this: any, ...args: Parameters<T>): void {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    }

    debounced.cancel = function() {
        clearTimeout(timeout);
    };

    return debounced as any;
}